import { SubBody3 } from '@flatsy/core/MaterialUi/Typo'
import { format } from '@flatsy/utils/Functions/DateTime/Datefns'
import { Box } from '@material-ui/core'
import { add } from 'date-fns'
import React from 'react'
import { DateTime } from '@flatsy/utils/dates'
import i18n from '@flatsy/utils/translations'
import { useUtils } from '../../Hooks'
import useStyle from './Styles'
import { componentsProps } from './Type'

/**
 * A REFACTO
 */
const Days: React.FC<componentsProps> = ({
  slotsByDay,
  index,
  handleClickOnSlot,
}): React.ReactElement | null => {
  const { numberDays, screenXs } = useUtils()
  const classes = useStyle({ numberDays })

  let slotDay = add(new Date(), { days: index })
  let slotKeys = format(slotDay, 'P')
  let slot: string[] = slotsByDay[slotKeys]

  if (screenXs) {
    if (slotsByDay[Object.keys(slotsByDay)[index]]) {
      slotKeys = Object.keys(slotsByDay)[index]
      slotDay = new Date(slotsByDay[slotKeys][0])
      slot = slotsByDay[slotKeys]
    } else {
      return null
    }
  }

  const getLineSlot = () => {
    let maxSlot = 0
    let keys
    const slotArray = []

    if (slotsByDay !== undefined) {
      keys = Object.keys(slotsByDay)
    }

    keys &&
      keys.forEach((element) => {
        if (slotsByDay[element] && slotsByDay[element].length > maxSlot) {
          maxSlot = slotsByDay[element].length
        }
      })
    const slotRemaining = slot && maxSlot - slot.length

    if (slotRemaining === undefined) {
      for (let i = 0; i < maxSlot; i++) {
        slotArray.push(i)
      }
    }
    for (let i = 0; i < slotRemaining; i++) {
      slotArray.push(i)
    }

    return slotArray
  }

  return (
    <div className={classes.day} key={index}>
      <Box className={classes.header}>
        <span className={classes.dateGrey}>
          {i18n.t('@date_day', { value: DateTime.fromJSDate(slotDay) })}
        </span>
        <span className={classes.dateDark}>{DateTime.fromJSDate(slotDay).day}</span>
        <span className={classes.dateGrey}>
          {i18n.t('@date_month', { value: DateTime.fromJSDate(slotDay) })}
        </span>
      </Box>
      <div className={classes.line} />
      <div className={classes.slots}>
        {slot?.map((start) => (
          <button
            key={start}
            type="button"
            className={classes.slot}
            onClick={() => handleClickOnSlot(start)}
          >
            <SubBody3 className={classes.slotInner}>
              {i18n.t('@date_time', { value: DateTime.fromISO(start) })}
            </SubBody3>
          </button>
        ))}
        {getLineSlot().map(() => {
          return <div className={classes.lineCalendar} />
        })}
      </div>
    </div>
  )
}

export default Days
